import kebabCase from "lodash/kebabCase";

export const getCssVariable = (token: string): string | undefined =>
    typeof getComputedStyle == "undefined"
        ? ""
        : getComputedStyle(document.body)
              .getPropertyValue(`--${kebabCase(token)}`)
              ?.trim();

/**
 * Retrieves a CSS custom property value from the document body based on a friendly color key.
 *
 * @param color - The camelCase or spaced color token (e.g., "primaryBlue") that maps to a `--primary-blue` CSS variable.
 * @returns The resolved color string (e.g., `#0f172a`) or an empty string/undefined when `getComputedStyle` is unavailable.
 */
export const getColor = (color: string): string | undefined => getCssVariable(color);
